module.exports = __webpack_public_path__ + "static/vf-button-outerwear.d5570384.svg";